import { CustomMedia } from '@gsc/types'

const customPseudoRegExp = /\((--[A-z][\w-]*)\)/

export function resolveMedia(media: string, customMedia: CustomMedia): string {
  return media.replace(customPseudoRegExp, (match, key) => customMedia[key] || match)
}
